
import { onMounted, Ref, ref, watch } from "vue";
import { mask } from "../../mixins";

const __default__ = {
  name: "modernInput",
  props: {
    /** It will relate the label and the input */
    id: {
      required: true,
      type: [String, Number]
    },

    /** Defines the input type, it will implicate the input's behaviour */
    type: {
      required: true,
      type: String
    },

    /** It is a pointer to input and is the input's name too (this will be visible by users). */
    label: {
      required: true,
      type: String
    },

    options: {
      required: false,
      type: Array,
      default: () => []
    },

    /** Do not let the form be submitted before the input that has this attribute be filled correctly */
    required: {
      required: false,
      type: Boolean
    },

    /** It controls if the input's value must be masked */
    hasMask: {
      required: false,
      type: Boolean
    },

    /** Receives the mask that will be applied to input's value if hasMaks be true */
    inputMask: {
      required: false,
      type: String
    },

    min: {
      type: [String, Number]
    },

    max: {
      type: String
    },

    maxLength: {
      type: [String, Number]
    },

    /** Used to make a connection with another variable outside this component */
    userData: {
      required: false,
      default: () => null
    },

    form: {
      required: true,
      type: [String, Number]
    },

    pattern: {
      required: false,
      type: String
    },

    title: {
      required: false,
      type: String
    },

    color: {
      required: false,
      type: String,
      default: "var(--primary-color)"
    },

    disabled: {
      type: Boolean
    }
  },

  setup(props) {
    /** Used to control the label state */
    const isInputFocused: Ref<boolean> = ref(false);

    /** This will be called when the input receive and event of type focus or blur and will be used to control the label state
     * @param value Refers to the current content_provider coming from the input.
     * @param isFocused Receive true when the event type is focus and false when the event type is blur. */
    const toggleLabelClass = (value, isFocused: boolean): void => {
      isInputFocused.value = isFocused;
      if (value && !isFocused) {
        isInputFocused.value = true;
      }
    };

    /** Serves to handle when the input receive data coming from another source that do not come from user */
    watch(
      () => props.userData,
      () => {
        if (props.userData) isInputFocused.value = true;
      }
    );

    return {
      isInputFocused,
      toggleLabelClass,
      mask
    };
  }
};

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "7c9634b8": (_ctx.color)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__